import React from 'react';
import {currentResource, labels} from '../../../util/utils';
import utilityfunctions from '../../../util/utilityfunctions';
import CommonAdminTable from '../Common/CommonAdminTable';
import useDetailsSelector from '../Common/Hooks/GetDetailsHook';

function EntitiesTable() {
	const entitiesInfo = useDetailsSelector('orgStructure');
	const entitiesTableConfig = {
		columns: [
			{
				label: labels.nameLabel,
				sortable: true,
				propName: 'entityName',
				width: '25%'
			},
			{
				label: labels.parentEntity,
				sortable: true,
				propName: 'parentEntityName',
				width: '25%'
			},
			{
				label: labels.connectEngagements,
				sortable: true,
				propName: 'countEngagements',
				width: '25%'
			},
			{
				label: labels.connectedGroups,
				sortable: true,
				propName: 'countAccessGroups',
				width: '25%'
			}
		],
		tableClassName: 'tabs-proj-table entities-table',
		items: entitiesInfo,
		sortConfig: {
			sortBy: 'entityName',
			sortIsAscending: true
		}
	};
	return (
		<section>
			<CommonAdminTable config={entitiesTableConfig} />
		</section>
	);
}

export default EntitiesTable;
